import React, { useState, useEffect } from "react";
import i18n from "i18next";
// Fabric Imports
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../../helpers/constants";
import { IosArrowRtl24Regular, MailRegular } from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button } from "@fluentui/react-components";
import { EmailColumns } from "./EmailColumns";
import { IEmail } from "../../../Models/IEmails";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import Header from "../../Layout/Header";
import useWindowSize from "../../../helpers/useWindowSize";
import HeaderTextAnimation from "../../Layout/HeaderTextAnimation";

function Emails() {
  const windowSize = useWindowSize();
  const navigate = useNavigate();

  const [emails, setEmails] = useState<IEmail[]>([]);
  const [clickedEmail, setClickedEmail] = useState<IEmail | undefined>();

  const [templateBody, setTemplateBody] = useState("");

  const getTemplateBody = (lang: string) => {
    fetchWrapper
      .get(baseUrl + "/api/emailtemplate/GetTemplateBody?lang=" + lang)
      .then((result: any) => {
        setTemplateBody(result.body);
      });
  };
  const columns = EmailColumns({
    onClickedEmail: (item: IEmail) => {
      navigate("/sales/emails?guid=" + item.guid);
    },
  });
  useEffect(() => {
    getTemplateBody("en");
  }, []);
  const getAllEmails = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/vertrieb/GetAllEmails`)
      .then((data: any) => {
        setEmails(data);
      });
  };
  useEffect(() => {
    getAllEmails();
  }, []);
  useEffect(() => {
    if (emails) {
      if (window.location) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid) {
            setClickedEmail(
              emails.find((x: IEmail) => x.guid == guid)
                ? emails.find((x) => x.guid == guid)
                : undefined,
            );
          }
        } else {
          setClickedEmail(undefined);
        }
      }
    }
  }, [emails, window.location.search]);
  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1570 ||
              windowSize.width < 1024 ||
              !clickedEmail) && (
              <Button
                icon={<MailRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/sales/emails");
                }}
              >
                {i18n.t<string>("email").toLocaleUpperCase()}
              </Button>
            )}
            {windowSize.width < 1571 &&
              windowSize.width > 1024 &&
              clickedEmail && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    navigate("/sales/emails");
                  }}
                  appearance="transparent"
                >
                  <MailRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {clickedEmail && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  <HeaderTextAnimation text={clickedEmail.subject} />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        {clickedEmail == undefined && (
          <LuebPagedDataGrid
            columns={columns}
            items={emails}
            resizableColumns={true}
            columnSizingOptions={{
              empfängerId: { minWidth: 250, defaultWidth: 280 },
              betreffId: { minWidth: 250, defaultWidth: 550 },
              gesendetId: { minWidth: 100, defaultWidth: 150 },
            }}
          />
        )}

        {clickedEmail != undefined && (
          <div
            dangerouslySetInnerHTML={{
              __html: clickedEmail
                ? templateBody.replace("{content}", clickedEmail.body)
                : "<div></div>",
            }}
          />
        )}
      </div>
    </div>
  );
}

export default Emails;
